import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Card from "../Card/Card";
import ExpandableTable from "../Fundamentals/Tables/ExpandedableTable";
import dateUtils from "../../Utils/dateUtils";
import {GdprHistoryStatusLabels, GdprTriggerTypeLabels, RetentionActionLabels} from "../../Constants/Gdpr/GdprConstants";
import settingsActions from "../../Actions/settingsActions";
import Spinner, {SpinnerSize} from "../Fundamentals/Spinner/Spinner";

function GdprHistoryTable({ histories }) {
    const dispatch = useDispatch();
    
    const historiesLoading = useSelector(state => state.CommonReducer?.dataLoading?.gdpr_histories);
    const loadingStates = useSelector(state => state.CommonReducer?.dataLoading || {});
    
    const handleRowExpand = (historyId) => {
        const history = histories.find(h => h.id === historyId);
        if (!history?.actions || history.actions.length === 0) {
            dispatch(settingsActions.getActionsForHistory(historyId));
        }
    };
    
    return (
        <Card>
            <Card.Header>
                <Card.Header.Title>History</Card.Header.Title>
            </Card.Header>
            <Card.Content isLoading={historiesLoading}>
                <ExpandableTable>
                    <thead>
                    <tr>
                        <th>Trigger Type</th>
                        <th>Executed At</th>
                        <th>Finished At</th>
                        <th>Total Records</th>
                        <th>Status</th>
                    </tr>
                    </thead>
                    <ExpandableTable.Body>
                        {histories.map(history => {
                            const isLoading = loadingStates[`gdpr_actions_${history.id}`] || false;
                            
                            return (
                                <ExpandableTable.Row key={history.id}>
                                    <ExpandableTable.Row.Expandable onClick={() => handleRowExpand(history.id)}>
                                        <td>{GdprTriggerTypeLabels[history.gdprTriggerType]}</td>
                                        <td>{dateUtils.formatDateAndTime(history.executedAt)}</td>
                                        <td>{history.finishedAt ? dateUtils.formatDateAndTime(history.finishedAt) : '-'}</td>
                                        <td>{history.totalRecordsAffected}</td>
                                        <td>{GdprHistoryStatusLabels[history.status]}</td>
                                    </ExpandableTable.Row.Expandable>
                                    <ExpandableTable.Row.Expanded>
                                        {isLoading ? (
                                            <tr>
                                                <td colSpan="6" className="text-center py-6">
                                                    <Spinner size={SpinnerSize.SMALL} />
                                                </td>
                                            </tr>
                                        ) : (history.actions?.length ?? 0) > 0 ? (
                                            <>
                                                <tr className="bold">
                                                    <td></td>
                                                    <td className="bold">Record Type</td>
                                                    <td className="bold">Action</td>
                                                    <td colSpan={100} className="bold">Count</td>
                                                </tr>
                                                {history.actions.map((action, index) => (
                                                    <tr key={index}>
                                                        <td></td>
                                                        <td>{action.recordTypeName}</td>
                                                        <td>{RetentionActionLabels[action.action]}</td>
                                                        <td colSpan={100}>{action.affectedRecords}</td>
                                                    </tr>
                                                ))}
                                            </>
                                        ) : (
                                            <tr>
                                                <td colSpan="6">
                                                    <em>No actions recorded{history.errorDetails && ` - Error: ${history.errorDetails}`}</em>
                                                </td>
                                            </tr>
                                        )}
                                    </ExpandableTable.Row.Expanded>
                                </ExpandableTable.Row>
                            );
                        })}
                    </ExpandableTable.Body>
                </ExpandableTable>
            </Card.Content>
        </Card>
    );
}
export default GdprHistoryTable;

